import { render, staticRenderFns } from "./StockviewRegistrationFilter.vue?vue&type=template&id=346b3375&"
import script from "./StockviewRegistrationFilter.vue?vue&type=script&lang=js&"
export * from "./StockviewRegistrationFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports